/* Tienda — carrito liviano en localStorage + helpers. */
export const CART_KEY = "odf_cart";

export const formatCLP = (n) => "$" + Math.round(Number(n || 0)).toLocaleString("es-CL");

export function getCart() {
  try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; }
}

export function setCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("odf-cart"));
}

export function addToCart(producto, cantidad = 1) {
  const cart = getCart();
  const i = cart.findIndex((x) => x.producto_id === producto.id);
  if (i >= 0) cart[i].cantidad = Math.min(99, cart[i].cantidad + cantidad);
  else cart.push({ producto_id: producto.id, slug: producto.slug, nombre: producto.nombre,
    precio: producto.precio_final, imagen: (producto.imagenes || [])[0] || "", cantidad });
  setCart(cart);
  return cart;
}

export const cartCount = () => getCart().reduce((a, x) => a + x.cantidad, 0);
export const cartSubtotal = () => getCart().reduce((a, x) => a + x.precio * x.cantidad, 0);

export const imgSrc = (id) =>
  `${process.env.REACT_APP_BACKEND_URL || ""}/api/tienda/imagenes/${id}`;

export function youtubeEmbed(url) {
  const m = (url || "").match(/(?:youtu\.be\/|v=|shorts\/)([\w-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : "";
}

export const REGIONES = ["Arica y Parinacota","Tarapacá","Antofagasta","Atacama","Coquimbo",
  "Valparaíso","Metropolitana","O'Higgins","Maule","Ñuble","Biobío","La Araucanía",
  "Los Ríos","Los Lagos","Aysén","Magallanes"];
